import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Col, Accordion, Card } from 'react-bootstrap';
import moment from 'moment';
import { sendAlert } from '../../actions/utils';
import { ComponentDataTable, DefaultModal } from '../../components';
import {
  debounceIndexSelectionProcessesRequest,
  deleteSelectionProcessRequest
} from '../../requests/selectionProcesses';
import SelectionProcessFilter from './SelectionProcessFilter';

const SelectionProcessDataTable = props => {
  const { columns, moreData, setMoreData } = props;

  const [selectionProcesses, setSelectionProcesses] = useState([]);
  const [amount, setAmount] = useState(0);
  const [onRequest, setOnRequest] = useState(true);

  const [modalShow, setModalShow] = useState(false);
  const [destroyItem, setDestroyItem] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();

  const [customParams, setCustomParams] = useState({});
  const [defaultStartDate, setDefaultStartDate] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState('0');
  const [showFilters] = useState(true);

  const handleSuccessRemove = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Solicitud eliminada correctamente' }));
    setMoreData(!moreData);
  };

  const handleSelectionProcessDelete = () => {
    setOnRequest(true);
    deleteSelectionProcessRequest(destroyItem.id, {
      dispatch,
      successCallback: handleSuccessRemove,
      callback: () => {
        setModalShow(false);
        setOnRequest(false);
      }
    });
  };

  const handleSuccessIndex = response => {
    const responseSelectionProcesses = response.data.data;
    const { amount: responseAmount } = response.data.metadata;
    setSelectionProcesses(responseSelectionProcesses);
    setAmount(responseAmount);
    setOnRequest(false);
  };

  const handleIndexRequest = async params => {
    setOnRequest(true);
    const sendParams = { ...params, ...customParams };
    const request = async () =>
      debounceIndexSelectionProcessesRequest({
        dispatch,
        params: sendParams,
        successCallback: handleSuccessIndex
      });
    request();
  };

  const handleButtonClick = (item, action) => {
    switch (action) {
      case 'show':
        history.push(`/selection_processes/${item.id}`);
        break;
      case 'edit':
        history.push(`/selection_processes/${item.id}/edit`);
        break;
      case 'destroy':
        setModalShow(true);
        setDestroyItem(item);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'status':
        return { sort_status: name };
      case 'job_title_name':
        return { sort_job_titles: name };
      case 'job_management_name':
        return { sort_job_managements: name };
      default:
        return { sort_column: name };
    }
  };

  const handleFilterSubmit = values => {
    const params = {
      query: values.filterName || '',
      date_from: values.filterDateFrom ? moment(values.filterDateFrom, 'DD/MM/YYYY').format('DD/MM/YYYY') : '',
      filter_job_management: values.filterJobManagement || '',
      filter_job_title: values.filterJobTitle || '',
      filter_process_type: values.filterProcessType || '',
      status: values.filterStatus || ''
    };

    Object.keys(params).forEach(k => {
      if (!params[k]) delete params[k];
    });

    setCustomParams(params);
    setDefaultStartDate(values.filterDateFrom ? moment(values.filterDateFrom) : null);
    setMoreData(!moreData);
  };

  const handleClearFilters = () => {
    setCustomParams({});
    setDefaultStartDate(null);
    setMoreData(!moreData);
  };

  return (
    <>
      <Accordion className="my-4" activeKey={activeAccordion} onSelect={key => setActiveAccordion(key)}>
        <Card className="mb-2">
          <Col className="top-header-employee py-2">
            <Accordion.Toggle
              as={Col}
              eventKey="0"
              className="card-header-title d-flex justify-content-between align-items-center"
              onClick={() => setActiveAccordion(activeAccordion === '0' ? null : '0')}
              style={{ textAlign: 'right', cursor: 'pointer' }}
            >
              <span>Filtros de Búsqueda</span>
              <span className="h4 mr-2">{activeAccordion === '0' ? '−' : '+'}</span>
            </Accordion.Toggle>
          </Col>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="employee-filters">
              {showFilters && <SelectionProcessFilter formRequest={handleFilterSubmit} onClear={handleClearFilters} />}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      <div className="data-table-yellow">
        <ComponentDataTable
          defaultStartDate={defaultStartDate}
          columns={columns(handleButtonClick)}
          handleSortCase={sortColumnCase}
          totalRows={amount}
          data={selectionProcesses}
          moreData={moreData}
          onRequest={onRequest}
          resourceRequest={handleIndexRequest}
          customParams={customParams}
          onRowClicked={item => handleButtonClick(item, 'show')}
          pointerOnHover
        />
      </div>

      <DefaultModal
        title="Eliminar Proceso de Selección"
        body="¿Estás seguro que deseas eliminar este proceso de selección?"
        show={modalShow}
        disabled={onRequest}
        handleClose={() => setModalShow(false)}
        handleConfirm={handleSelectionProcessDelete}
        variantBtnSave="primary"
      />
    </>
  );
};

export default SelectionProcessDataTable;
